import * as State from 'components/desktop/Accessory/AccessoryState';
import { useHandler } from 'hooks/useHandler';

export default function useAccessoryState(initial: State.Type) {
	const [state, rf] = useHandler<State.Type>(initial);
	return {
		state,
		handlers: {
			addSynonym: rf.createNoArgReducer(State.addSynonym),
			changeSynonym: rf.createReducer(State.changeSynonym),
			deleteSynonym: rf.createReducer(State.deleteSynonym),
			getAndSetSuggestedTags: rf.createReducerAsync(State.getAndSetSuggestedTags),
			load: rf.createReducer(State.load),
			setCategories: rf.createReducer(State.setCategories),
			setCharacteristic: rf.createReducer(State.setCharacteristic),
			setDensity: rf.createReducer(State.setDensity),
			setName: rf.createReducer(State.setName),
			setPrice: rf.createReducer(State.setPrice),
			setSelectedCultureCode: rf.createReducer(State.setSelectedCultureCode),
			setTagIds: rf.createReducer(State.setTagIds),
			setUnitWeights: rf.createReducer(State.setUnitWeights),
			translateSingleName: rf.createReducerAsync(State.translateSingleName),
			translateAllNames: rf.createReducerAsync(State.translateAllNames),
			uploadImage: rf.createReducerAsync(State.uploadImage),
		},
	};
}

export type AccessoryDetailHandlers = ReturnType<typeof useAccessoryState>['handlers'];
